module.exports = __webpack_public_path__ + "img/image1.e5bfb1ec.png";